// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__14uaH","footer":"styles_footer__NAbQs","slideInSearchBar":"styles_slideInSearchBar__xg7TO"};